import { render, staticRenderFns } from "./VendorRequest.vue?vue&type=template&id=f8f37e5c"
import script from "./VendorRequest.vue?vue&type=script&lang=js"
export * from "./VendorRequest.vue?vue&type=script&lang=js"
import style0 from "./VendorRequest.vue?vue&type=style&index=0&id=f8f37e5c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports